import React from "react";
import { Box, Link as MuiLink } from "@mui/material";
import { NavLink } from "react-router-dom";
import NavigationTopBar from "./NavigationTopBar";
import { NAV_LINKS } from "../../constants/permissions";
import { useUser } from "../../context/UserContext";

const NavigationDesktop = () => {
  const { canAccess } = useUser();
  // Hide product sections the user cannot view; non-product links always show.
  const navLinks = NAV_LINKS.filter(
    ({ productKey }) => !productKey || canAccess(productKey)
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: "1200px",
        margin: "1rem auto 0 auto",
      }}
    >
      <Box>
        <NavigationTopBar />
      </Box>
      <Box
        component="nav"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "2rem 0 3rem 0",
        }}
      >
        {navLinks.map(({ label, path }) => (
          <MuiLink
            key={path}
            component={NavLink}
            to={path}
            underline="none"
            color="inherit"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              fontWeight: 400,
              fontSize: "1rem",
              width: "10rem",
              height: "2rem",
              borderBottom: "0.4rem solid #f0f0f0",
              "&.active": {
                borderBottom: "0.4rem solid #E54F9C",
              },
              "&:hover": {
                borderBottom: "0.4rem solid #000000",
              },
            }}
          >
            {label}
          </MuiLink>
        ))}
      </Box>
    </Box>
  );
};

export default NavigationDesktop;
